import { AppPlans } from '../enums/app-plans.enum';

/** Legacy typo stored in MongoDB before the Standard rename. */
export const LEGACY_PLAN_NAME_STANDART = 'Standart';

/** Legacy typo for the yearly plan name. */
export const LEGACY_PLAN_NAME_STANDART_YEARLY = 'Standart Yearly';

const LEGACY_TO_CANONICAL: Readonly<Record<string, AppPlans>> = {
    [LEGACY_PLAN_NAME_STANDART]: AppPlans.Standard,
    [LEGACY_PLAN_NAME_STANDART_YEARLY]: AppPlans.Standard_Yearly,
};

const CANONICAL_PLAN_VALUES = new Set<string>(Object.values(AppPlans));

/**
 * Maps legacy or canonical plan name strings to {@link AppPlans}.
 * Unknown values fall back to {@link AppPlans.Free}.
 */
export function normalizePlanName(planName: string | AppPlans | null | undefined): AppPlans {
    if (!planName) {
        return AppPlans.Free;
    }

    const legacy = LEGACY_TO_CANONICAL[planName];
    if (legacy) {
        return legacy;
    }

    if (CANONICAL_PLAN_VALUES.has(planName)) {
        return planName as AppPlans;
    }

    return AppPlans.Free;
}
